import type { GetPageErrorKeyProps, PageErrorKey } from "./page-error.type";

export const getPageErrorKey = ({
  status,
  isContextIssue,
}: GetPageErrorKeyProps): PageErrorKey => {
  if (isContextIssue) return "contextNotFound";
  if (status === 404) return "notFound";
  return "default";
};

export const getPageErrorImageName = (errorKey: PageErrorKey): string => {
  if (errorKey === "contextNotFound") return "context-not-found.svg";
  if (errorKey === "notFound") return "not-found.svg";
  return "default-error.svg";
};
